import initRouter from './index'
import {
  Home,
  ContactUs,
  Events,
  EatDrink,
  Faq,
  PrivateBooking,
  Offers,
  OfferDetail,
  RestaurantDetail,
  EventDetail,
  Pages,
  RoomPages,
} from './views'

/**
 * @function defineRouter
 *
 * @param {Store} store Instance of Vuex Store; used to sync router to correct store
 */
export default function defineRouter (store) {
  const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        endpoint: 'page/home.json',
      },
    },
    {
      path: '/stay-with-us',
      name: 'StayWithUs',
      component: RoomPages,
      meta: {
        menuColor: 'dark',
        endpoint: 'page/stay-with-us.json',
      },
    },
    {
      path: '/shared-rooms',
      name: 'SharedRooms',
      component: RoomPages,
      meta: {
        menuColor: 'dark',
        endpoint: 'page/shared-rooms.json',
      },
    },
    {
      path: '/private-rooms',
      name: 'PrivateRooms',
      component: RoomPages,
      meta: {
        menuColor: 'dark',
        endpoint: 'page/private-rooms.json',
      },
    },
    {
      path: '/kex-family',
      name: 'KexFamily',
      component: Pages,
      meta: {
        menuColor: 'dark',
        endpoint: 'page/kex-family.json',
      },
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: Pages,
      meta: {
        menuColor: 'dark',
        endpoint: 'page/about-us.json',
      },
    },
    {
      path: '/spaces',
      name: 'Spaces',
      component: Pages,
      meta: {
        endpoint: 'page/spaces.json',
      },
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      component: ContactUs,
      meta: {
        pageColor: 'dark',
        endpoint: 'page/contact.json',
      },
    },
    {
      path: '/events',
      name: 'Events',
      component: Events,
      meta: {
        pageColor: 'dark',
        endpoint: 'page/events.json',
      },
    },
    {
      path: '/eventscalendar',
      name: 'EventsCalendar',
      component: Events,
      meta: {
        pageColor: 'dark',
        endpoint: 'page/events.json',
      },
    },
    {
      path: '/eat-drink',
      name: 'EatDrink',
      component: EatDrink,
      meta: {
        endpoint: 'page/eat-drink.json',
      },
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq,
      meta: {
        menuColor: 'dark',
        endpoint: 'page/faq.json',
      },
    },
    {
      path: '/booking',
      name: 'PrivateBooking',
      component: PrivateBooking,
      meta: {
        pageColor: 'dark',
        endpoint: 'page/booking.json',
      },
    },
    {
      path: '/eventinquiry',
      name: 'EventInquiry',
      component: PrivateBooking,
      meta: {
        pageColor: 'dark',
        endpoint: 'page/booking.json',
      },
    },
    {
      path: '/offers',
      name: 'Offers',
      component: Offers,
      meta: {
        pageColor: 'dark',
        endpoint: 'page/offers.json',
      },
    },
    {
      path: '/offers/:slug',
      name: 'OfferDetail',
      component: OfferDetail,
      meta: {
        pageColor: 'dark',
      },
    },
    {
      path: '/eat-drink/:slug',
      name: 'RestaurantDetail',
      component: RestaurantDetail,
      meta: {
        pageColor: 'dark',
      },
    },
    {
      path: '/events/:slug',
      name: 'EventDetail',
      component: EventDetail,
      meta: {
        pageColor: 'dark',
      },
    },
    {
      path: '/:slug',
      name: 'Page',
      component: Pages,
      meta: {
        menuColor: 'dark',
        endpoint: 'page/:slug.json',
      },
    },
  ]

  const beforeEach = (to, from, next) => {
    if (to.name === 'Page') {
      to.meta.endpoint = 'page/' + to.params.slug + '.json'
    }

    if (to.query.token) {
      store
        .dispatch('setPageData', { name: to.name, path: to.meta.endpoint, token: encodeURI(to.query.token), preview: encodeURI(to.query['x-craft-preview']) })
        .then(() => {
          next()
        })
    } else if (to.meta.endpoint) {
      store
        .dispatch('setPageData', { name: to.name, path: to.meta.endpoint })
        .then(() => {
          next()
        })
    } else {
      next()
    }
  }

  return initRouter(routes, store, { beforeEach })
}
